import { createAction, props } from '@ngrx/store';
import { AuthUser, UserCountry } from '@core/domain/model/user/auth-user.model';
import { MyAccountEditFormModel } from '@pages/my-account/my-account-edit/model/my-account-edit-form.model';

export const userActions = {
  fetchUser: createAction('[User] fetch user data'),
  setUser: createAction('[User] set user data', props<{ user: AuthUser }>()),
  setError: createAction('[User API] user fetch errored out', props<{ error: string }>()),
  editUser: createAction('[My Account] edit user data', props<{ editBody: MyAccountEditFormModel }>()),
  midFetchUser: createAction('[My Account] fetch user data after my account update'),
  updateUser: createAction('[My Account API] update user data', props<{ user: AuthUser }>()),
  fetchImpersonation: createAction('[Impersonation] fetch token by email', props<{ impersonationEmail: string }>()),
  setImpersonation: createAction('[Impersonation API] set token ', props<{ impersonationToken: string | null }>()),
  chooseCountry: createAction('[User Country] choose which country', props<{ users: AuthUser[] }>()),
  setCountry: createAction('[User Country] set user country', props<{ user: AuthUser; multi?: boolean }>()),
  changeCountry: createAction('[User Country] change country', props<{ country: UserCountry }>()),
  showDataProtectionDialog: createAction('[Data Protection] show dialog', props<{ user: AuthUser }>()),
  userDataProtectionResponse: createAction(
    '[Data Protection] user response to data protection',
    props<{ response: boolean; country: UserCountry }>()
  ),
  apiDataProtectionResponse: createAction('[Data Protection API] received API response', props<{ response: boolean }>()),
  dataProtectionAccepted: createAction('[Data Protection] accepted '),
  markWebAsReady: createAction('[User] mark web as ready'),
};
